import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { dashboardQueries } from '@/services/dashboard/dashboard.queries';

export const useDashboardOverview = () => {
  const { data, isFetched } = useQuery({
    ...dashboardQueries.dashboardOverview(),
    select: (res) => ({
      ...res,
      data: res.data,
    }),
  });
  return { overview: data?.data || [], isFetched };
};

export const useDashboardReservationPlanAnalytics = () => {
  const { data, isFetched } = useQuery({
    ...dashboardQueries.reservationPlanAnalytics(),
    select: (res) => ({
      ...res,
      data: res.data,
    }),
  });

  return { reservationPlanAnalytics: data?.data || [], isFetched };
};

export const useDashboardTopAffiliateRanks = () => {
  const { data, isFetched } = useQuery({
    ...dashboardQueries.topAffiliateRanks(),
    select: (res) => ({
      ...res,
      data: res.data,
    }),
  });

  return { topAffiliateRanks: data?.data || [], isFetched };
};
